import { Enums } from '@cornerstonejs/metadata';
export const CalibrationTypes = Enums.CalibrationTypes;
export default Enums.CalibrationTypes;
